<template>
    <div class="ocr-form-loading">
        <!-- Document section -->
        <div class="ocr-form-loading__section">
            <div class="ocr-form-loading__section-header">
                <CompassSkeleton
                    :variant="CompassEnums.SkeletonVariantType.SQUARE"
                    :size="CompassEnums.SkeletonSize.MEDIUM"
                />
                <CompassSkeleton
                    class="ocr-form-loading__section-title"
                    :size="CompassEnums.SkeletonSize.LARGE"
                />
            </div>
            <div class="ocr-form-loading__fields">
                <div class="ocr-form-loading__row">
                    <div class="ocr-form-loading__field ocr-form-loading__field--supplier">
                        <CompassSkeleton class="ocr-form-loading__label" />
                        <CompassSkeleton
                            class="ocr-form-loading__input"
                            :size="CompassEnums.SkeletonSize.EXTRA_LARGE"
                        />
                    </div>
                    <div class="ocr-form-loading__field ocr-form-loading__field--date">
                        <CompassSkeleton class="ocr-form-loading__label" />
                        <CompassSkeleton
                            class="ocr-form-loading__input"
                            :size="CompassEnums.SkeletonSize.EXTRA_LARGE"
                        />
                    </div>
                    <div class="ocr-form-loading__field ocr-form-loading__field--date">
                        <CompassSkeleton class="ocr-form-loading__label" />
                        <CompassSkeleton
                            class="ocr-form-loading__input"
                            :size="CompassEnums.SkeletonSize.EXTRA_LARGE"
                        />
                    </div>
                </div>
                <div class="ocr-form-loading__row">
                    <div class="ocr-form-loading__field ocr-form-loading__field--full">
                        <CompassSkeleton
                            class="ocr-form-loading__label ocr-form-loading__label--short"
                        />
                        <CompassSkeleton
                            class="ocr-form-loading__input"
                            :size="CompassEnums.SkeletonSize.EXTRA_LARGE"
                        />
                    </div>
                </div>
                <CompassSkeleton
                    class="ocr-form-loading__button-skeleton"
                    :size="CompassEnums.SkeletonSize.EXTRA_LARGE"
                />
            </div>
        </div>

        <!-- Products section -->
        <div class="ocr-form-loading__section">
            <div class="ocr-form-loading__section-header">
                <CompassSkeleton
                    :variant="CompassEnums.SkeletonVariantType.SQUARE"
                    :size="CompassEnums.SkeletonSize.MEDIUM"
                />
                <CompassSkeleton
                    class="ocr-form-loading__section-title"
                    :size="CompassEnums.SkeletonSize.LARGE"
                />
            </div>
            <div class="ocr-form-loading__table">
                <div v-for="row in 7" :key="`row-${row}`" class="ocr-form-loading__table-row">
                    <CompassSkeleton
                        v-if="row % 2 !== 0"
                        class="ocr-form-loading__table-cell ocr-form-loading__table-cell--checkbox"
                        :variant="CompassEnums.SkeletonVariantType.SQUARE"
                        :size="CompassEnums.SkeletonSize.MEDIUM"
                    />
                    <div
                        v-else
                        class="ocr-form-loading__table-cell ocr-form-loading__table-cell--checkbox"
                    />
                    <CompassSkeleton
                        class="ocr-form-loading__table-cell ocr-form-loading__table-cell--description"
                        :size="CompassEnums.SkeletonSize.LARGE"
                    />
                    <CompassSkeleton
                        class="ocr-form-loading__table-cell ocr-form-loading__table-cell--qty"
                        :size="CompassEnums.SkeletonSize.LARGE"
                    />
                    <CompassSkeleton
                        class="ocr-form-loading__table-cell ocr-form-loading__table-cell--price"
                        :size="CompassEnums.SkeletonSize.LARGE"
                    />
                    <CompassSkeleton
                        class="ocr-form-loading__table-cell ocr-form-loading__table-cell--tax"
                        :size="CompassEnums.SkeletonSize.LARGE"
                    />
                    <CompassSkeleton
                        class="ocr-form-loading__table-cell ocr-form-loading__table-cell--total"
                        :size="CompassEnums.SkeletonSize.LARGE"
                    />
                    <CompassSkeleton
                        class="ocr-form-loading__table-cell ocr-form-loading__table-cell--action"
                        :variant="CompassEnums.SkeletonVariantType.SQUARE"
                        :size="CompassEnums.SkeletonSize.MEDIUM"
                    />
                </div>
            </div>
            <div class="ocr-form-loading__totals">
                <CompassSkeleton
                    class="ocr-form-loading__totals-block"
                    :variant="CompassEnums.SkeletonVariantType.BLOCK"
                />
            </div>
        </div>

        <!-- Payment section -->
        <div class="ocr-form-loading__section">
            <div class="ocr-form-loading__section-header">
                <CompassSkeleton
                    :variant="CompassEnums.SkeletonVariantType.SQUARE"
                    :size="CompassEnums.SkeletonSize.MEDIUM"
                />
                <CompassSkeleton
                    class="ocr-form-loading__section-title"
                    :size="CompassEnums.SkeletonSize.LARGE"
                />
            </div>
            <div class="ocr-form-loading__fields">
                <div class="ocr-form-loading__payment-subheader">
                    <CompassSkeleton
                        class="ocr-form-loading__payment-subheader-title"
                        :size="CompassEnums.SkeletonSize.LARGE"
                    />
                    <CompassSkeleton
                        :variant="CompassEnums.SkeletonVariantType.SQUARE"
                        :size="CompassEnums.SkeletonSize.MEDIUM"
                    />
                </div>
                <div class="ocr-form-loading__row">
                    <div class="ocr-form-loading__field ocr-form-loading__field--pay-date">
                        <CompassSkeleton class="ocr-form-loading__label" />
                        <CompassSkeleton
                            class="ocr-form-loading__input"
                            :size="CompassEnums.SkeletonSize.EXTRA_LARGE"
                        />
                    </div>
                    <div class="ocr-form-loading__field ocr-form-loading__field--pay-reference">
                        <CompassSkeleton
                            class="ocr-form-loading__label ocr-form-loading__label--wide"
                        />
                        <CompassSkeleton
                            class="ocr-form-loading__input"
                            :size="CompassEnums.SkeletonSize.EXTRA_LARGE"
                        />
                    </div>
                    <div class="ocr-form-loading__field ocr-form-loading__field--pay-amount">
                        <CompassSkeleton
                            class="ocr-form-loading__label ocr-form-loading__label--short"
                        />
                        <CompassSkeleton
                            class="ocr-form-loading__input"
                            :size="CompassEnums.SkeletonSize.EXTRA_LARGE"
                        />
                    </div>
                    <div class="ocr-form-loading__field ocr-form-loading__field--pay-method">
                        <CompassSkeleton class="ocr-form-loading__label" />
                        <CompassSkeleton
                            class="ocr-form-loading__input"
                            :size="CompassEnums.SkeletonSize.EXTRA_LARGE"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.ocr-form-loading {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-4);

    &__section {
        background: var(--colors-common-background-default);
        border-radius: var(--spacing-1);
        box-shadow: var(--elevation-1);
        padding: var(--spacing-4);
    }

    &__section-header {
        display: flex;
        align-items: center;
        gap: var(--spacing-2);
        margin-bottom: var(--spacing-4);
    }

    &__section-title {
        width: 226px;
    }

    &__fields {
        max-width: 652px;
    }

    &__row {
        display: flex;
        gap: var(--spacing-3);
        margin-bottom: var(--spacing-4);

        &:last-child {
            margin-bottom: 0;
        }
    }

    &__field {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-1);

        &--supplier {
            width: 284px;
        }

        &--date {
            width: 168px;
        }

        &--full {
            width: 100%;
        }

        &--pay-date {
            width: 168px;
        }

        &--pay-reference {
            width: 150px;
        }

        &--pay-amount {
            width: 108px;
        }

        &--pay-method {
            width: 176px;
        }
    }

    &__label {
        width: 115px;

        &--short {
            width: 87px;
        }

        &--wide {
            width: 137px;
        }
    }

    &__input {
        width: 100%;
    }

    &__button-skeleton {
        width: 146px;
        height: 32px;
    }

    &__table {
        border-bottom: 1px solid var(--colors-common-border-lighter);
        padding-bottom: var(--spacing-1);
        margin-bottom: var(--spacing-3);
    }

    &__table-row {
        display: flex;
        align-items: center;
        height: 48px;
    }

    &__table-cell {
        padding: 0 var(--spacing-1);

        &--checkbox {
            width: 40px;
        }

        &--description {
            width: 200px;
        }

        &--qty {
            width: 80px;
        }

        &--price {
            width: 140px;
        }

        &--tax {
            width: 100px;
        }

        &--total {
            width: 140px;
        }

        &--action {
            width: 48px;

            margin-left: auto;
        }
    }

    &__totals {
        width: 255px;
        margin-left: auto;
    }

    &__payment-subheader {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: var(--spacing-2);
    }

    &__payment-subheader-title {
        width: 126px;
    }
}
</style>
